import { EBookingStatus, TBooking, TBookingStore } from "@/types/booking";
import { create } from "zustand";
import { persist } from "zustand/middleware";

const emptyBooking = {
  id: null,
  password: null,
  event: null,
  activity: null,
  status: EBookingStatus.DRAFT,
  user: null,
  otherUsers: [],
  people: 0,
  coupon: null,
  createdAt: new Date(),
  isEditable: true,
  needsEnglish: false,
  paymentId: null,
};

const useBookingStore = create<TBookingStore>()(
  persist(
    (set) => ({
      booking: emptyBooking,
      setBooking: (booking: TBooking) => set({ booking }),
      resetBooking: () =>
        set({
          booking: emptyBooking,
        }),
    }),
    {
      name: "booking",
    }
  )
);

export default useBookingStore;
